import { Stepper, Step, StepLabel, Box, CircularProgress, Grid, Typography } from "@mui/material";
import { PATIENT_OF } from "../../../utils/constants";
import { ArrowBack } from "@mui/icons-material";
import PatientDetails from "./PatientDetails";
import PatientType from "./PatientType";
import UploadReferences from "./UploadReferences";
import MicrotiaImg from "../../../assets/images/Microtia.jpg";
import ArtesiaImg from "../../../assets/images/Artesia.png";
import AnotiaImg from "../../../assets/images/Anotia.jpg";
import Audiogram from "./Audiogram";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../store/actions/modalAction";
import CustomDialog from "../../../components/layouts/common/CustomDialog";
import { CenteredBox } from "../../../components/layouts/common/boxes";

const HearNUCreateUI = ({
  fields,
  setFields,
  loading,
  onSubmit,
  activeStep,
  steps,
  handleBack,
  handleCaptureMeasurement,
}) => {
  const isUpdate = Boolean(fields?.id);
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <>
      <CustomDialog
        id={isUpdate ? "HearNUUpdate" : "HearNUCreate"}
        loading={loading}
        title={isUpdate ? "Update Patient" : "Create Patient"}
        confirmText={
          activeStep === steps.length - 1
            ? isUpdate
              ? "Update"
              : "Create"
            : "Next"
        }
        disabledSubmit={loading}
        closeText="Close"
        onSubmit={onSubmit}
        onClose={handleClose}
      >
        <Typography variant="h4" color="red" sx={{ mt: 1, mb: 2 }}>
          {fields?.err}
        </Typography>

        <Box display="flex" alignItems="center" sx={{ mb: 0.5 }}>
          {activeStep > 0 && (
            <Grid item>
              <ArrowBack
                onClick={handleBack}
                sx={{
                  ml: 1,
                  cursor: "pointer",
                  fontSize: "38px",
                  color: "#A91674",
                  "&:hover": { color: "#7a1053" },
                }}
              />
            </Grid>
          )}
        </Box>

        {/* Stepper */}
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Step-specific Content */}
        {loading ? (
          <CenteredBox>
            <CircularProgress />
          </CenteredBox>
        ) : (
          <Box sx={{ mt: 4 }}>
            {activeStep === 0 && (
              <PatientDetails
                fields={fields}
                setFields={setFields}
                loading={loading}
              />
            )}

            {activeStep === 1 && (
              <PatientType
                fields={fields}
                setFields={setFields}
                PATIENT_OF={PATIENT_OF}
                MicrotiaImg={MicrotiaImg}
                ArtesiaImg={ArtesiaImg}
                AnotiaImg={AnotiaImg}
              />
            )}

            {activeStep === 2 && (
              <Audiogram fields={fields} setFields={setFields} />
            )}

            {activeStep === 3 && (
              <UploadReferences
                fields={fields}
                setFields={setFields}
                loading={loading}
                handleCaptureMeasurement={handleCaptureMeasurement}
              />
            )}
          </Box>
        )}
      </CustomDialog>
    </>
  );
};

export default HearNUCreateUI;
